import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../../contexts/UserContext';
import { isHelpEnabledForUser } from '../config/helpConfig';

const HelpAccessGate = ({ children }) => {
    const { state } = useUser();

    if (!state?.user) return <Navigate to="/" replace />;
    if (!isHelpEnabledForUser(state.user)) return <Navigate to="/dashboard" replace />;

    return children;
};

export default HelpAccessGate;
